
export const init = (automation) => {
    return {
        guidePoint: undefined,
        selectedPoint: undefined,
        pointHasMoved: undefined,
        pointDragging: undefined,
        guidePoint: undefined,
        automations: automation ? automation.automations : []
    };

};

export const reducer = (state, action) => {
    switch (action.type) {
    case 'setGuidePoint':
        return {
            ... state,
            guidePoint: action.payload
        };
    case 'setSelectedPoint':
        return {
            ... state,
            selectedPoint: action.payload
        };
    case 'setPointHasMoved':
        return {
            ... state,
            pointHasMoved: action.payload
        };
    case 'setPointDragging':
        return {
            ... state,
            pointDragging: action.payload
        };
    case 'setAutomations':
        return {
            ... state,
            automations: action.payload
        };
    case 'setGuidePoint':
        return {
            ... state,
            guidePoint: action.payload
        };
    default:
        return state;
    }
};
